'use client';

import { Menu as BaseMenu } from '@base-ui/react/menu';

import { type Component, type ComponentProps } from '../../types/component';

interface MenuBaseProps {
  /**
   * Sets the Menu open/closed state (controlled).
   */
  isOpen?: boolean;
  /**
   * Whether the Menu is open by default (uncontrolled).
   *
   * @default false
   */
  defaultOpen?: boolean;
  /**
   * Handler that is called when the Menu's open state changes.
   */
  onOpenChange?: (isOpen: boolean) => void;
  /**
   * Disables the menu (dismiss, keyboard navigation). Must also be set on the
   * trigger element to prevent interaction.
   *
   * @default false
   */
  isDisabled?: boolean;
  /**
   * Menu.Trigger + Menu.Popup.
   */
  children?: React.ReactNode;
}

type MenuProps = ComponentProps<MenuBaseProps>;

type MenuComponent = Component<MenuBaseProps>;

const MenuRoot: MenuComponent = (props) => {
  const {
    isOpen,
    defaultOpen = false,
    onOpenChange,
    isDisabled = false,
    children,
  } = props;

  return (
    <BaseMenu.Root
      open={isOpen}
      defaultOpen={defaultOpen}
      onOpenChange={onOpenChange}
      disabled={isDisabled}
    >
      {children}
    </BaseMenu.Root>
  );
};

MenuRoot.displayName = 'Menu';

export { MenuRoot, type MenuProps, type MenuBaseProps };
